import { Stack } from '@mantine/core'
import { SystemTaskInfo } from './SystemTaskInfo'
import { SystemTaskForm } from './SystemTaskForm'
import { SystemTaskDetailsProps } from './types'

export function SystemTaskDetails({
  task,
  formData,
  onFormDataChange,
  markAsCompleted,
  onMarkAsCompletedChange,
  disabled = false,
  hasPackage,
  attachments,
}: SystemTaskDetailsProps) {
  return (
    <Stack gap="lg">
      <SystemTaskInfo task={task} />

      <SystemTaskForm
        data={formData}
        onChange={onFormDataChange}
        markAsCompleted={markAsCompleted}
        onMarkAsCompletedChange={onMarkAsCompletedChange}
        disabled={disabled}
        isMarkkuTask={!task.isUserTask}
        hasPackage={hasPackage}
        attachments={attachments}
      />
    </Stack>
  )
}
